<template>
  <div @mouseover="hoverRow(-1)" @mouseleave="downRow">
    <v-tooltip top>
      <template v-slot:activator="{ on }">
        <div v-on="on">
          <v-card
            width="150px"
            height="190px"
            @mouseover="showAction = true"
            @mouseout="showAction = false"
          >
            <v-img
              class="white--text align-end"
              :height="'150px'"
              :width="'150px'"
              :position="'center'"
              :src="image"
            ></v-img>

            <v-card-actions class="action pa-0">
              <v-row justify="center" no-gutters>
                <button-rounded
                  class="mr-1"
                  @click="$emit('clickButton', { seloCertificacao, type:'view' })"
                  iconName="eye"
                  :iconSize="16"
                  v-if="disabledButtons[0] && showButton"
                />
                <button-rounded
                  class="mr-1"
                  @click="$emit('clickButton', { seloCertificacao, type:'edit' })"
                  iconName="edit"
                  :iconSize="16"
                  v-if="edit && disabledButtons[1] && showButton"
                />
                <button-rounded
                  @click="$emit('clickButton', { seloCertificacao, type:'delete' })"
                  iconName="trash"
                  :iconSize="16"
                  v-if="edit && disabledButtons[2] && showButton"
                />
              </v-row>
            </v-card-actions>
          </v-card>
        </div>
      </template>
      <span>{{seloCertificacao.tipoSelo.descricao}}</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  props: {
    seloCertificacao: {
      type: Object,
      required: true
    },
    canEdit: {
      type: Boolean,
      required: true
    },

    disabledButtons: {
      type: Array,
      required: false,
      default: () => {
        return [true, true, true]
      },
      note: '0 => view, 1 => edit, 2 => delete'
    }
  },
  data () {
    return {
      showAction: false,
      objSeloCertificacao: this.seloCertificacao,
      edit: this.canEdit,
      image: '',
      hoverIndex: -1,
      showButton: false
    }
  },
  async beforeMount () {
    this.tokenBearer = localStorage.getItem('tokenBearer')

    this.getImage()
  },
  methods: {
    async getImage () {
      this.image = `${this.$appConfig.config.API}/api/arquivos/${this.objSeloCertificacao.tipoSelo.arquivo.container}/${this.objSeloCertificacao.tipoSelo.arquivo.uuid}`
    },

    hoverRow (index) {
      this.showButton = true
      this.hoverIndex = index
    },
    downRow () {
      this.hoverIndex = -100
      this.showButton = false
    }
  }
}
</script>

<style scoped>
.action {
  width: 100%;
  height: 40px;
  border-top: 1px solid #dee2e6;
}
</style>
